import "@/businessLogicRegistry";
import "@/lib/pwaConfig"; // Initialize PWA configuration
import { ConfigWrapper } from "@/components/ConfigWrapper";
import { ThemeProvider } from "@/context/ThemeContext";
import "@/i18n";
import "@/styles/index.css";
import { createRoot } from "react-dom/client";

// StrictMode removed to prevent double API calls in development
// React 18 StrictMode intentionally double-mounts components in dev mode
createRoot(document.getElementById("root")!).render(
  <ThemeProvider>
    <ConfigWrapper />
  </ThemeProvider>
);
